import { render, staticRenderFns } from "./viplevel.vue?vue&type=template&id=18da2d3d&scoped=true"
import script from "./viplevel.vue?vue&type=script&lang=js"
export * from "./viplevel.vue?vue&type=script&lang=js"
import style0 from "./viplevel.vue?vue&type=style&index=0&id=18da2d3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da2d3d",
  null
  
)

export default component.exports